import type { FeatureFlagBridge } from './plugins/feature-flags/feature-flag-bridge';

export function registerDefaultPlugins(): void {
  // Dev tools disabled for this build
}

export function buildWindowApi(
  _featureFlagBridge: FeatureFlagBridge,
): NonNullable<NonNullable<Window['__ACME_B2B__']>['devTools']> {
  return {} as NonNullable<NonNullable<Window['__ACME_B2B__']>['devTools']>;
}

export function registerPanelShortcut(): () => void {
  return () => {};
}

export function initDevTools(): void {
  // Dev tools disabled for this build
}
